import { secondAxios as axios } from '../../../../../../api/axios';
import { tokenHeader } from "../../../allProjectsPage/ProjectsTable/ProjectTasksPage/tokenHeader"

export const createTask = async ({ task, plantId, accessToken }) => {
  console.log('creating plant task', task, plantId);
  // Use the plant-specific endpoint and send task data with plantId
  // Ensure taskCode is included
  return await axios.post(
    '/task/create/plant',
    { 
      ...task, 
      plantId,
      taskCode: task.taskCode || '',
      estimatedTime: Number(task.estimatedTime) || 0,
    },
    tokenHeader(accessToken),
  );
};

export const getAllTasks = async ({ plantId, accessToken }) => {
  console.log('fetching plant tasks for plantId:', plantId);
  try {
    const { data } = await axios.get(
      '/task/all/plant/' + plantId,
      tokenHeader(accessToken),
    );
    console.log('plant tasks data:', data);
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('Error fetching plant tasks:', error);
    // Return empty array on error to show empty table
    return [];
  }
};

export const getOneTask = async ({ taskId, accessToken }) => {
  try {
    const { data } = await axios.get(
      `/task/${taskId}`,
      tokenHeader(accessToken),
    );
    return data;
  } catch (error) {
    console.error('Error fetching task:', error);
    throw error;
  }
};

export const updateTask = async ({ task, accessToken }) => {
  console.log('updating plant task', task);
  // Use PATCH endpoint with task id in URL
  // Ensure taskCode and estimatedTime are properly formatted
  return await axios.patch(
    `/task/${task.id}`,
    {
      ...task,
      taskCode: task.taskCode || '',
      estimatedTime: Number(task.estimatedTime) || 0,
    },
    tokenHeader(accessToken),
  );
};

export const deleteTask = async ({ taskId, accessToken }) => {
  console.log('deleting plant task', taskId);
  return await axios.delete(
    `/task/${taskId}`,
    tokenHeader(accessToken),
  );
};

export const archiveTask = async ({ id, accessToken }) => {
  console.log('archiving plant task', id);
  return await axios.patch(
    '/task/archive/' + id,
    {},
    tokenHeader(accessToken),
  );
};

// Comments API functions
export const getComments = async ({ taskId, accessToken }) => {
  try {
    const { data } = await axios.get(
      `/task/comments/${taskId}`,
      tokenHeader(accessToken),
    );
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('Error fetching comments:', error);
    return [];
  }
};

export const createComment = async ({ comment, file, accessToken }) => {
  console.log('creating comment', comment, file);
  const formData = new FormData();
  
  // Append all comment fields to formData
  Object.keys(comment).forEach(key => {
    formData.append(key, comment[key]);
  });
  
  // Append file if provided
  if (file) {
    formData.append('attachment', file);
  }

  return await axios.post(
    '/task/comments',
    formData,
    {
      ...tokenHeader(accessToken),
      headers: {
        ...tokenHeader(accessToken).headers,
        'Content-Type': 'multipart/form-data',
      },
    },
  );
};

